<script lang="ts">
	import { Helper, Input } from "flowbite-svelte-v1";
	import parse from "parse-duration";
	import type { Behavior, TimeoutTrigger } from "#gen/pages/v2/page_pb.js";
	import Label from "#lib/components/Label.svelte";

	interface Props {
		behavior: Behavior;
		onChange?: (behavior: Behavior) => void;
	}

	const { behavior, onChange }: Props = $props();

	let error: string | undefined = $state();

	function handleTimeoutChange(event: Event) {
		const timeout = (event.target as HTMLInputElement).value;
		if (!validate(timeout)) {
			error = "Value must be a valid duration string (ex 1s, 5m, 2h)";
			return;
		}
		error = undefined;
		const trigger = behavior.trigger?.value?.value as TimeoutTrigger;
		if (trigger) {
			trigger.timeout = timeout;
			onChange?.(behavior);
		}
	}

	function validate(timeout: string): boolean {
		return parse(timeout) !== null;
	}

	function getTimeout(behavior: Behavior): string {
		const trigger = behavior.trigger?.value?.value as TimeoutTrigger;
		if (trigger) {
			return trigger.timeout ?? "";
		}
		return "";
	}
</script>

<form class="grid grid-cols-2 gap-2">
	<div class="flex min-w-0 flex-1 flex-col gap-1">
		<Label for="timeout" class="required text-sm font-medium text-gray-700">Timeout</Label>
		<Input id="timeout" value={getTimeout(behavior)} onchange={e => handleTimeoutChange(e)} />
		{#if error}
			<Helper color="red" role="alert">{error}</Helper>
		{/if}
	</div>
</form>
